import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ArrowRight, CalendarMonth } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import { getEvents } from '../../api/api';
const Events = () => {
    const navigate = useNavigate();
    const allEvents = useSelector((state) => state.events.events);
    // let date = events[0].todayDate.split(' ')[0]; 

    // let d = date.getDate().toString()+date.getMonth().toString()+date.getFullYear().toString(); 
    // console.log(date); 
    // const onGoing = events.filter((event) event.date  )
    const events = allEvents.future;
    const current = allEvents.current;
    const past = allEvents.past;
    const onGoingEvents = current;
    const pastEvents =past;

    console.log(allEvents);
    const fHeight = window.innerWidth > 767 ? '99vh' : '70vh';
    let sHeight = window.innerWidth > 767 ? '50vh' : '50vh'
    let sImageHeight = window.innerWidth > 767 ? '230px' : '300px'
    
    if(!events){
      sHeight = window.innerWidth > 767 ? '90vh' : '50vh'
      sImageHeight = window.innerWidth > 767 ? '390px' : '300px'
    }
    console.log(events);
    useEffect(() => {
      allEvents.length === 0 && getEvents();
      // getEvents();
    }, [])
    useEffect(() => {
      console.log(allEvents)
      console.log(allEvents.length);
    }, [allEvents])
  return (
    <div className='row'
    id='events'
        // style={{ backgroundColor: '#F8E9EC' }}
        >
        <p className='small-header mt-2 text-center'> <u>EVENTS</u> </p>
            {
              events && 
              <div className={'col-12'}>
                <div className='row event-slider-container1'
          style={{ 
            // backgroundColor: 'rgb(35, 35, 82)',
            // height: `${fHeight}`
          }}
          >
              <div className=' col-12 ms-2'
              style={{ 
                // height: '65vh'
              }}
              >
              {/* <i> <p className="news-title text-white text-center" > UPCOMING EVENT </p> </i> */}
              <p className='small-header mt-2 mb-0 pb-0 text-center'> UPCOMING EVENTS  </p>
                
              <div className='mt-0 row justify-content-center'>
                <div className='col-12'>
                <Carousel 
                // fade={true}
                controls= {false}
                indicators={false}
                interval={5000}
                pause={false}
                variant='dark'
                className='eventSlider'
                style={{
                  
              }}
                >
                  
                    {
                        events && events.slice(0, 1).map(function(event,index){
                            return (
                                <Carousel.Item key={index}
                                className=''
                                variant='dark'
                                style={{
                                //   height:window.innerWidth > 450? 700 : 600,
                                  
                              }}
                                >
                                  <div className='d-flex my-0'>
                                  <CalendarMonth  fontSize='large'/>
                                  <p 
                                      className='p-1 pb-0 '
                                      style={{  fontWeight: 700, fontSize: 21 }}>UP NEXT  </p>
                                    
                                </div>
                                <p className='text-center my-0'
                                style={{  fontWeight: 600, fontSize: 18,  }}
                                >
                                    {/* The Upcoming Tournament of Dan Maje Nupe. */}
                                    {event.title}
                                </p>
                                <img
                                className="text-center event-slider-image1"
                                width={'100%'}
                                // height={'550px'}
                                src={event.img}
                                alt={`${event.title} - Image - ${index}`}
                                />
                                
                                </Carousel.Item>
                            )
                        })
                    } 
                </Carousel>
                </div> 
                </div>
            
              </div>
              
                </div>
                <hr/>
            </div>
            }
            <div className={'col-12'}>
               <div className='row'
               style={{ 
                // height: '80vh'
                }}
               >
                    {
                      current && 
                      <div className={current ? 'col-lg-6 col-md-6 col-12' : 'col-12'}>
            
                        <div className='row m-1 card event-slider-container2'
                        style={{ 
                          // backgroundColor: 'rgb(35, 35, 82)',
                          // height: `${sHeight}`
                        }}
                        >
                            <div className=' col-12'
                            style={{ 
                              // height: '47vh'
                            }}
                            >
                            {/* <i> <p className="news-title text-white text-center" > UPCOMING EVENT </p> </i> */}
                            <p className='small-header mt-2 mb-0 pb-0 text-center'> ONGOING EVENTS  </p>
                            
                            <div className='mt-0 row justify-content-center'>
                              <div className='col-12 '>
                              <Carousel 
                              // fade={true}
                              controls= {false}
                              indicators={false}
                              interval={3500}
                              pause={false}
                              variant='dark'
                              className='eventSlider'
                              style={{
                                
                            }}
                              prevIcon={ 
                                      ""
                                      // <ArrowCircleLeft fontSize='large' className='t-arrow-icon'/>
                                      }
                              nextIcon={
                                      ""
                                  // <ArrowCircleRightSharp fontSize="large" className="t-arrow-icon" />
                              }
                              >
                                {
                                      current.map(function(event,index){
                                          return (
                                              <Carousel.Item key={index}
                                              className=''
                                              variant='dark'
                                              style={{
                                              //   height:window.innerWidth > 450? 700 : 600,
                                                
                                            }}
                                              >
                                                  <div className='d-flex my-0'>
                                                  <CalendarMonth  fontSize='large'/>
                                                  <p 
                                                      className='p-1 pb-0 '
                                                      style={{  fontWeight: 700, fontSize: 21 }}>ON-GOING  </p>
                                                      
                                                  </div>
                                                  <p className='text-center my-0'
                                                  style={{  fontWeight: 600, fontSize: 18,  }}
                                                  >
                                                      {/* The Upcoming Tournament of Dan Maje Nupe. */}
                                                      {event.title}
                                                  </p>
                                                  <img
                                                  className="text-center event-slider-image2"
                                                  width={'100%'}
                                                  // height={`${sImageHeight}`}
                                                  src={event.img}
                                                  alt={`${event.title} - Image - ${index}`}
                                                  />
                                              
                                              </Carousel.Item>
                                          )
                                      })
                                  } 
                              </Carousel>
                              </div> 
                              </div>
                          
                            </div>
                            {/* <div className='col d-flex align-items-center justify-content-end'>
                              <button
                              onClick={()=> navigate('events')}
                              className='btn btn-color btn-lg d-flex justify-content-center align-items-center'
                              style={{ fontWeight: 700, fontSize: 14, width: '130px' }}
                              // variant='primary'
                              >
                                All Events <ArrowRight />
                              </button>
                            </div> */}
                        </div>
                    </div>
                    }
                    {
                      pastEvents && 
                      <div className={current ? 'col-lg-6 col-md-6 col-12' : 'col-12'}>
            
                          <div className='row m-1 card event-slider-container2'
                          style={{ 
                            // backgroundColor: 'rgb(35, 35, 82)',
                            // height: `${sHeight}`
                          }}
                          >
                              <div className=' col-12'
                              style={{ 
                                // height: '47vh'
                              }}
                              >
                              {/* <i> <p className="news-title text-white text-center" > UPCOMING EVENT </p> </i> */}
                              <p className='small-header mt-2 mb-0 pb-0 text-center'> PAST EVENTS MEMORIES  </p>
                            
                              <div className='mt-0 row justify-content-center'>
                                <div className='col-12'>
                                <Carousel 
                                // fade={true}
                                controls= {false}
                                indicators={false}
                                interval={3000}
                                pause={false}
                                variant='dark'
                                className='eventSlider'
                                style={{
                                  
                              }}
                                prevIcon={ 
                                        ""
                                        // <ArrowCircleLeft fontSize='large' className='t-arrow-icon'/>
                                        }
                                nextIcon={
                                        ""
                                    // <ArrowCircleRightSharp fontSize="large" className="t-arrow-icon" />
                                }
                                >
                                  {
                                        pastEvents.map(function(event,index){
                                            return (
                                                <Carousel.Item key={index}
                                                className=''
                                                variant='dark'
                                                style={{
                                                //   height:window.innerWidth > 450? 700 : 600,
                                                  
                                              }}
                                                >
                                                    <div className='d-flex my-0'>
                                                    <CalendarMonth  fontSize='large'/>
                                                    <p 
                                                        className='p-1 pb-0 '
                                                        style={{  fontWeight: 700, fontSize: 21 }}>MEMORIES  </p>
                                                        
                                                    </div>
                                                    <p className='text-center my-0'
                                                    style={{  fontWeight: 600, fontSize: 18,  }}
                                                    >
                                                        {/* The Upcoming Tournament of Dan Maje Nupe. */}
                                                        {event.title}
                                                    </p>
                                                    <img
                                                    className="text-center event-slider-image2"
                                                    width={'100%'}
                                                    // height={`${sImageHeight}`}
                                                    src={event.img}
                                                    alt={`${event.title} - Image - ${index}`}
                                                    style={{ 
                                                        // height: '100%',
                                                        // maxHeight: '30vh'
                                                      }}
                                                    />
                                                
                                                </Carousel.Item>
                                                
                                            )
                                        })
                                    } 
                                </Carousel>
                                </div> 
                                </div>
                            
                              </div>
                          </div>
                      </div>
                    }
               </div>
            </div>
            {/* <div className='col d-flex align-items-center justify-content-end pe-4'>
            <button
            onClick={()=> navigate('events')}
            className='btn btn-color btn-lg d-flex justify-content-center align-items-center'
            style={{ fontWeight: 700, fontSize: 14, width: '160px', height: '50px' }}
            // variant='primary'
            >
              View Events <ArrowRight />
            </button>
          </div> */}
        </div>
      

  )
}

export default Events